import Footer from '@/pages/footer';
import Header from '@/pages/header'
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React, { useEffect, useState } from 'react'
import styles from "../../../../styles/DocumentDetail.module.css"
import Link from 'next/link';
import SwiperArrow from '@/pages/images/swiperArrow';
import PortalLaptop from '@/pages/images/portalLaptop';
import NotificationPortal from '@/pages/images/notificationPortal';
import Theme from '@/pages/images/theme';
import { useTranslation } from 'next-i18next';
import LoginMethod from '@/pages/images/loginMethod';
import { useRouter } from 'next/router';
import PageSeo from '@/components/seo/PageSeo';

const markDocumentAsViewed = (documentId: number) => {
  if (typeof window !== "undefined") {
    let viewedDocuments = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
    if (!viewedDocuments.includes(documentId)) {
      viewedDocuments.push(documentId);
      localStorage.setItem('serviceManagementViewedDocuments', JSON.stringify(viewedDocuments));
    }
  }
};

interface ServiceDocumentStep {
  id: number;
  icon: React.ComponentType<{ color?: string }>;
  docNumber: string;
  title: string;
  link: string;
}

const LoginMethodPage = (_props: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { t } = useTranslation("documentsTranslate");
  const router = useRouter();
  const [viewedDocuments, setViewedDocuments] = useState<number[]>([]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const viewed = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
      setViewedDocuments(viewed);
      markDocumentAsViewed(2);
      // Update state after marking as viewed
      const updated = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
      setViewedDocuments(updated);
    }
  }, []);

  const serviceDocumentStep: ServiceDocumentStep[] = [
    {
      id: 1,
      icon: PortalLaptop,
      docNumber: 'Doc 1',
      title: `${t("serviceManagementDocPortalTitle")}`,
      link: '/service-management/documents/portal'
    },
    {
      id: 2,
      icon: LoginMethod,
      docNumber: 'Doc 2',
      title: `${t("serviceManagementDocLoginMethodTitle")}`,
      link: '/service-management/documents/login-method'
    },
    {
      id: 3,
      icon: Theme,
      docNumber: 'Doc 3',
      title: `${t("serviceManagementDocThemeTitle")}`,
      link: '/service-management/documents/content-theme'
    },
    {
      id: 4,
      icon: NotificationPortal,
      docNumber: 'Doc 4',
      title: `${t("serviceManagementDocPortalNotificationTitle")}`,
      link: '/service-management/documents/notification'
    }
  ]

  return (
    <>
      <PageSeo
        title={`${t("serviceManagementDocLoginMethodTitle")} | Stoneity`}
        description={t("serviceManagementDocLoginDescriptionOne")}
        locale={router.locale}
        keywords={router.locale === "tr"
          ? "giriş yöntemi dokümanı, kimlik doğrulama, Stoneity"
          : "login method document, authentication, Stoneity"
        }
      />
      <Header />
      <div className={styles.pageFlex}>
        <div className={styles.documentDetailWrapper}>
          <div className={styles.stepWrapper}>
            {serviceDocumentStep.map((docStep, index) => {
              const isDocViewed = viewedDocuments.includes(docStep.id);
              const IconComponent = docStep.icon;
              return (
                <Link key={index} href={docStep.link} className={styles.stepperItem} style={{ width: "auto", flex: "1 1" }} onClick={() => {
                  markDocumentAsViewed(docStep.id);
                  const updated = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
                  setViewedDocuments(updated);
                }}>
                  <div className={`${styles.stepIconWrapper} ${isDocViewed ? styles.completed : ""}`}>
                    {IconComponent && <IconComponent color={isDocViewed ? "#fff" : "#03555E"} />}
                  </div>
                  <div className={styles.stepName}>{docStep.title}</div>
                  <div className={styles.stepDoc}>{docStep.docNumber}</div>
                </Link>
              )
            })}
          </div>
          <div className={styles.documentDetailTop}>
            <div className={styles.responsiveDocumentCounter}>Doc 2</div>
            <Link className={styles.swiperArrowWrapper} href={'/service-management/documents/portal'} style={{ transform: "rotate(180deg)" }}><SwiperArrow /></Link>
            {t("serviceManagementDocLoginMethodTitle")}
            <Link className={styles.swiperArrowWrapper} href={'/service-management/documents/content-theme'}><SwiperArrow /></Link>
          </div>
          <div className={styles.documentDetailPortalBottomWrapper}>
            <div className={styles.documentDetailTextPhaseWrapper}>
              <div className={styles.title}>{t("whatIs")}</div>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <div className={styles.explain}>{t("serviceManagementDocLoginDescriptionOne")}</div>
              </div>
            </div>
            <div className={styles.documentDetailTextPhaseWrapper}>
              <div className={styles.title}>{t("howToUse")}</div>
              <div className={styles.explain}>{t("serviceManagementDocLoginHowToUseDescriptionOne")}</div>
              <div className={styles.documentDetailTextPhaseWrapper}>
                <div className={styles.subtaskTitle}>{t("serviceManagementDocLoginHowToUseColumnTitleOne")}:</div>
                <div className={styles.subtaskTitleBold}>{t("serviceManagementDocLoginHowToUseColumnSubtaskTitleOne")}</div>
                <ul>
                  <li>
                    <span>{t("serviceManagementDocLoginHowToUseColumnSubtaskTextTitleOne")}:</span>
                    {t("serviceManagementDocLoginHowToUseColumnSubtaskTextExplainOne")}
                  </li>
                  <li>
                    <span>{t("serviceManagementDocLoginHowToUseColumnSubtaskTextTitleTwo")}:</span>
                    {t("serviceManagementDocLoginHowToUseColumnSubtaskTextExplainTwo")}
                  </li>
                </ul>
              </div>
              <div className={styles.documentDetailTextPhaseWrapper}>
                <div className={styles.subtaskTitleBold}>{t("serviceManagementDocLoginHowToUseColumnSubtaskTitleTwo")}</div>
                <div className={styles.subtaskTitle}>{t("serviceManagementDocLoginHowToUseColumnTitleTwo")}:</div>
                <ul>
                  <li>
                    <span>{t("serviceManagementDocLoginHowToUseColumnExplainTitleOne")}:</span>
                    {t("serviceManagementDocLoginHowToUseColumnExplainTextOne")}
                  </li>
                  <li>
                    <span>{t("serviceManagementDocLoginHowToUseColumnExplainTitleTwo")}:</span>
                    {t("serviceManagementDocLoginHowToUseColumnExplainTextTwo")}
                  </li>
                  <li>
                    <span>{t("serviceManagementDocLoginHowToUseColumnExplainTitleThree")}:</span>
                    {t("serviceManagementDocLoginHowToUseColumnExplainTextThree")}
                  </li>
                </ul>
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  <div className={styles.explain}>{t("serviceManagementDocLoginHowToUseDescriptionTwo")}</div>
                  <div className={styles.explain}>{t("serviceManagementDocLoginHowToUseDescriptionThree")}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || 'en', ['documentsTranslate', 'common'])),
    },
  };
};

export default LoginMethodPage;
